import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import 'line-awesome/dist/line-awesome/css/line-awesome.min.css';
import '../../styles/ApplicationForms.css';

const ApplicationForms = () => {
  const forms = [
    {
      id: 1,
      title: "Registration Form",
      description: "Student course registration form for new and continuing students",
      filename: "Registration-form.pdf"
    },
    {
      id: 2,
      title: "Semester Freeze Form",
      description: "Form to request a temporary pause in your academic studies",
      filename: "FREEZE-OF-SEMESTER-FORM.pdf"
    },
    {
      id: 3,
      title: "Semester Withdrawal",
      description: "Form for withdrawing from the current semester",
      filename: "AWARD-OF-GRADE-W-SEMESTER-WITHDRAWAL.pdf"
    },
    {
      id: 4,
      title: "Student Application Form",
      description: "General purpose student application form for various requests",
      filename: "STUDENT-APPLICATION-FORM.pdf"
    },
    {
      id: 5,
      title: "Student Clearance Form",
      description: "Clearance form required before graduation or leaving the university",
      filename: "Students-Clearance-Form-2024.pdf"
    }
  ];

  const handleDownload = (filename) => {
    // In a real app, this would point to actual files in your public directory
    const filePath = `/files/${filename}`;
    
    // Create a temporary anchor element
    const link = document.createElement('a');
    link.href = filePath;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <Helmet>
        <title>Download Lahore Garrison University Application Form 2025</title>
        <meta name="description" content="Download the official Lahore Garrison University application form for 2025 admissions. Easy, fast, and free for LGU students!" />
        <meta name="keywords" content="Lahore Garrison University application form download, LGU application form 2025, download LGU admission form, free application form for LGU students" />
      </Helmet>
      <Container className="page-container application-forms-container">
        <h1 className="section-title">Download Lahore Garrison University Application Form</h1>
        
        <div className="seo-content mb-4">
          <p>
            Are you a Lahore Garrison University (LGU) student looking to download the official application form for 2025 admissions? You're in the right place! At MicroGenie, we make it simple for students in Lahore, Pakistan, to access the authentic LGU application form directly from the university. No hassle, no new forms—just the official document you need.
          </p>
        </div>

        <h2 className="mb-3">How to Download the Official LGU Application Form</h2>
        <div className="download-instructions mb-4">
          <p>Follow these quick steps:</p>
          <ol>
            <li><strong>Click the Button:</strong> Use the "Download Now" link below to access the official form.</li>
            <li><strong>Get the PDF:</strong> You'll be directed to the latest Lahore Garrison University application form (sourced from lgu.edu.pk).</li>
            <li><strong>Fill and Submit:</strong> Print, complete, and submit it to LGU's relevant office.</li>
          </ol>
        </div>
        
        <p className="text-center mb-5">
          Download the application forms you need for university processes and submissions
        </p>

        <Row className="justify-content-center">
          {forms.map((form) => (
            <Col lg={8} className="mb-4" key={form.id}>
              <Card className="form-card">
                <Card.Body className="d-flex align-items-center">
                  <div className="form-icon">
                    <i className="la la-file-text" style={{ fontSize: '32px' }} aria-hidden="true"></i>
                  </div>
                  <div className="form-details flex-grow-1">
                    <h3 className="form-title">{form.title}</h3>
                    <p className="form-description mb-0">{form.description}</p>
                  </div>
                  <button 
                    onClick={() => handleDownload(form.filename)}
                    className="download-link"
                    aria-label={`Download ${form.title}`}
                  >
                    <i className="la la-download" style={{ fontSize: '20px' }} aria-hidden="true"></i>
                    <span>Download</span>
                  </button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        <div className="forms-note mt-5">
          <p>
            <strong>Note:</strong> All forms should be completed in full before submission. For any questions regarding these forms, 
            please contact the Student Affairs Office.
          </p>
        </div>
      </Container>
    </>
  );
};

export default ApplicationForms;
